import { msg } from '@lingui/core/macro';
import { FieldMetadataMessageDescriptorDef } from './types';

export const foodFields = {
  food_item: {
    displayName: msg({
      message: 'Food item',
      context: 'The purchased food item',
    }),
    externalDescription: msg({
      message: 'The purchased food item.',
      context: 'Food item',
    }),
  },
  food_processing_sector: {
    displayName: msg({
      message: 'Food processing sector',
      context: 'The processing sector for the purchased food item',
    }),
    externalDescription: msg({
      message: 'The processing sector for the purchased food item.',
      context: 'Food processing sector',
    }),
  },
  food_use_case: {
    displayName: msg({
      message: 'Food use case',
      context: 'Specifies if the food is a purchased or a sold product',
    }),
    externalDescription: msg({
      message:
        'The use case for the purchased food item, as an input or output in the value chain.',
      context: 'Food use case',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
